const formatBigNumber = value => {
  const num = parseFloat(value);
  if (isNaN(num)) {
    return value;
  }
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default formatBigNumber;
